import _debounce from "lodash-es/debounce";
import React, { createContext, useState, useEffect } from 'react';

/*  sharing a single-window resize event listener amongst all the components that use the Hook.
 */
export const ViewportContext = /*#__PURE__*/createContext({
  windowWidth: undefined,
  windowHeight: undefined
});
export const ViewportProvider = ({
  children
}) => {
  const [windowWidth, setWidth] = useState(window.innerWidth);
  const [windowHeight, setHeight] = useState(window.innerHeight);

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };
  /* Debouncing window.onresize will only call the event handler after the event has stopped firing for a certain amount of time. 
  This will ensure that your function will only be called once the resizing is “complete.”
   */


  const debounceWindowResize = _debounce(handleWindowResize, 500);

  useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
       the "windowWidth" state variable when the window size changes */
    window.addEventListener('resize', debounceWindowResize);
    /* If this component is re-rendered often, this could create a serious memory leak in our program. 
    We only ever need or want one event listener.
    If we always clean up established event listeners before creating new ones, we'll ensure a single listener */

    /*  If no cleanup, when this component is unmounted the “resize” event listener will linger in memory, 
    continuing to be called when the window is resized and will potentially cause issues. */

    return () => window.removeEventListener('resize', debounceWindowResize);
    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  }, []);
  /*  we store the values in the
     value of the Provider */

  return /*#__PURE__*/React.createElement(ViewportContext.Provider, {
    value: {
      windowWidth,
      windowHeight
    }
  }, children);
};
/*  
import React from "react";
import { ViewportContext, ViewportProvider } from "common-ui";

const MobileComponent = () => <p>"Hmmm... Why is your screen so small?"</p>;
const DesktopComponent = () => <p>"Wow, your screen is big!"</p>;

const MyComponent = () => {
  Rewrite the "useViewport" hook to pull the width and height values
   out of the context instead of calculating them itself 
  const useViewport = () => {
    const { width, height } = React.useContext(viewportContext);
    return { width, height };
  };
  const { width } = useViewport();
  console.log("width", width);
  const breakpoint = 620;

  return width < breakpoint ? <MobileComponent /> : <DesktopComponent />;
};

export default function App() {
   wrap the root of your application in the new ViewportProvider, 
   so that the newly rewritten useViewport Hook will have access to the Context when used further down in the component tree.
  return (
    <ViewportProvider>
      <MyComponent />
    </ViewportProvider>
  );
}
 */